import TellTaleType from "@/models/TellTaleType";

// iso starting with XX is made by us and not a real iso number
export const tellTales: TellTaleType[] = [
  {
    id: "aHgTUvVNozECnzWKttrAzfQ",
    name: "TellTale \u2013 Cooling air conditioning (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0027",
  },
  {
    id: "aAUwP8E6sOEqlsnGv2O26aQ",
    name: "TellTale \u2013 High beam light (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0082",
  },
  {
    id: "ajDUkjdwLJ0qfJ22K-VAgaA",
    name: "TellTale \u2013 Low beam light (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0083",
  },
  {
    id: "aMkPO33wjGUq3wIPaQBlufg",
    name: "TellTale \u2013 Turn signals (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0084",
  },
  {
    id: "aSAtnBkojtEaFzxw7ZymnaA",
    name: "TellTale \u2013 Warning (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0085",
  },
  {
    id: "aQx64L7hOyUCHSq4Yk8UzWw",
    name: "TellTale \u2013 Provision for people with disabilities (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0100",
  },
  {
    id: "a8Q59homXrESC9eF_I_JTWA",
    name: "TellTale \u2013 Parking brake (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0238",
  },
  {
    id: "akwb3o3ca-EeHUC0n8CcH5A",
    name: "TellTale \u2013 Brake system failure (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0239",
  },
  {
    id: "aAeh09lYLfEe730F3BsHuQw",
    name: "TellTale \u2013 Hatch open (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0242",
  },
  {
    id: "a_k4vXsZtUE-_BsDRLtkuJA",
    name: "TellTale \u2013 Fuel level (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0245",
  },
  {
    id: "aSePB4IiYY0iUpsuEdFoiEQ",
    name: "TellTale \u2013 Engine coolant temperature (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0246",
  },
  {
    id: "aomjucBvoI0GvQfP6x5xFug",
    name: "TellTale \u2013 Battery charging condition (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0247",
  },
  {
    id: "aTB4WSZ1Liky820zuITq3yw",
    name: "TellTale \u2013 Engine oil (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0248",
  },
  {
    id: "aZ2lcuopTPUGfT7bkJxIPVQ",
    name: "TellTale \u2013 Position lights on the side (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0456",
  },
  {
    id: "aGADigDnxGUu5iyp9_GHb5Q",
    name: "TellTale \u2013 Front fog light (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0633",
  },
  {
    id: "a6XeTsAE6Y0G3-J8QG3pBEg",
    name: "TellTale \u2013 Rear fog light (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0634",
  },
  {
    id: "a3zDfwQ0gmECjkU86wz7g4w",
    name: "TellTale \u2013 Heating while parked (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX008", // 0637
  },
  {
    id: "aj4q85rnNoUKnqs7nYU4ezw",
    name: "TellTale \u2013 Engine (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0640",
  },
  {
    id: "awexj9uo2zUSRtqT5L1mzBA",
    name: "TellTale \u2013 Service required - call for maintenance (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0717",
  },
  {
    id: "aou939u5PgU-QEfK_VosytA",
    name: "TellTale \u2013 Transmission fuild temperature (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "1168",
  },
  {
    id: "apo4g9NkoDUuxt5RNWuCumg",
    name: "TellTale \u2013 Transmission malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "1396",
  },
  {
    id: "aqCoYUSkhw0-BkSvUqVYnpQ",
    name: "TellTale \u2013 Anti-lock brake system failure (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "1407",
  },
  {
    id: "aa_q25iRzfU-JhaGiIXMEyg",
    name: "TellTale \u2013 Worn brake linings (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "1408",
  },
  {
    id: "a-nS6jV7zK0-7upgkw1ZsQA",
    name: "TellTale \u2013 Washer fluid (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "1422",
  },
  {
    id: "aDWQ6hgEoSky0R_bB1jd95g",
    name: "TellTale \u2013 Tire malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "1434",
  },
  {
    id: "aXyZkTFffjUG8ZX91GUtqXg",
    name: "TellTale \u2013 General failure (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "1603",
  },
  {
    id: "adJ4rZfqmrUGGtFssC27Weg",
    name: "TellTale \u2013 Engine oil temperature (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2426",
  },
  {
    id: "amcWBJBqvI0SjS_ACHS5RCQ",
    name: "TellTale \u2013 Engine oil level (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2427",
  },
  {
    id: "a_Nf5RW4CQkutgbIDXduDMQ",
    name: "TellTale \u2013 Engine coolant level (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2429",
  },
  {
    id: "asa7VI4F360yfzPrRS4gnQg",
    name: "TellTale \u2013 Steering fluid level (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2440",
  },
  {
    id: "aBVDg-D4a1kC5OpUCXHidVg",
    name: "TellTale \u2013 Steering malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2441",
  },
  {
    id: "aNutlAHM4NU6DoRdJeTx0jQ",
    name: "TellTale \u2013 Height control (leveling) (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2461",
  },
  {
    id: "ax57fWMd5N0Sq6zFH9D0F3w",
    name: "TellTale \u2013 Retarder (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2574",
  },
  {
    id: "a4IP-9BMQ40OpFpgR7b40pA",
    name: "TellTale \u2013 Engine emission system failure (MIL indicator) (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2596A",
  },
  {
    id: "aeDotGpnmEU-0nTY0cLvXog",
    name: "TellTale \u2013 Electronic Stability Control indication (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2630",
  },
  {
    id: "anQ63ZCxCVEmlMX2Ibz1_kQ",
    name: "TellTale \u2013 Brake light (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "003",
  },
  {
    id: "axYCB6KkC5EKBmbCTJccVaA",
    name: "TellTale \u2013 Trailer operation (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "ax27mbt0xMEG3u0o4cKjFrw",
    name: "TellTale \u2013 Stop request (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX011",
  },
  {
    id: "an3sO-nHsTE6CI9Wi-8DCxw",
    name: "TellTale \u2013 Stroller stop request (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX012",
  },
  {
    id: "a4i8j39lcJU2QjS0xRcJZKg",
    name: "TellTale \u2013 Bus stop brake (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX005",
  },
  {
    id: "ajljHwocgxEe04igskK0N8Q",
    name: "TellTale \u2013 AdBlue level (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2946",
  },
  {
    id: "aL557G_Zx0EmCRDOI_WBA7g",
    name: "TellTale \u2013 Chassis raising (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aaRZtWqUQaUCTeVeccz7UUA",
    name: "TellTale \u2013 Chassis lowering (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aZ7Sz6BYtOEyDqfU_1uE2-Q",
    name: "TellTale \u2013 Bus kneeling towards sidewalk (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX004",
  },
  {
    id: "ac83_3Av_0ECzUmapR4OsiQ",
    name: "TellTale \u2013 Engine compartment temperature (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX007",
  },
  {
    id: "aviuRIpfctkeXxkL7SKKLGw",
    name: "TellTale \u2013 Auxillary air pressure (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX002",
  },
  {
    id: "aPAxdGDggoEevvxdoYrDp_Q",
    name: "TellTale \u2013 Air filter clogged (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2432",
  },
  {
    id: "a61KSYEhl6k6wucnRYQ75nw",
    name: "TellTale \u2013 Fuel filter differential pressure (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2452",
  },
  {
    id: "adcDFuXB84Eyokc9vQX2-7A",
    name: "TellTale \u2013 Seat belt (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "0249",
  },
  {
    id: "aA7WHajZSgUmF4iZCkkZ8NA",
    name: "TellTale \u2013 Electronic Braking System (EBS) (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX006",
  },
  {
    id: "a_JdeHyHEt0KTPKCFISK97A",
    name: "TellTale \u2013 Lane departure indication (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2682",
  },
  {
    id: "anfPfFqWTPUuIp4fCpyCY2g",
    name: "TellTale \u2013 Advanced emergency braking system (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX001",
  },
  {
    id: "aW5J_aafcXEaE-hgXq-sJIw",
    name: "TellTale \u2013 Adaptive Cruise Control (ACC) (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2581",
  },
  {
    id: "adRlApm4QtUeJARFyMg_A0g",
    name: "TellTale \u2013 Trailer connection (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aSP0GNP8we0GFoNBnCUKl3Q",
    name: "TellTale \u2013 Trailer anti-lock brake system (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2444",
  },
  {
    id: "apHlQR9aH40KC0IxZ7GSreQ",
    name: "TellTale \u2013 Airbag (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2108",
  },
  {
    id: "aQVN36K1likuOl0P2o8VfDg",
    name: "TellTale \u2013 Trailer Electronic Braking System (EBS) (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "afcnnV0E97EOCwYsyfOXmvA",
    name: "TellTale \u2013 Tachograph indication (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX013",
  },
  {
    id: "aOoag6UpAN02PRjyYLLx1ZQ",
    name: "TellTale \u2013 Electronic Stability Control (ESC) switched off (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2649",
  },
  {
    id: "aVOgobV0uK0ybM78vn4w9tQ",
    name: "TellTale \u2013 Lane departure warning switched off (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX009",
  },
  {
    id: "aa7KtGYI380e4pXWMfToEyA",
    name: "TellTale \u2013 Engine emission filter (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2433",
  },
  {
    id: "aod_0H1XnTE66zfLNXX1rvQ",
    name: "TellTale \u2013 Electric motor failure (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2633B",
  },
  {
    id: "aRKiNmV12Kku1YazsqtRl-w",
    name: "TellTale \u2013 AdBlue tampering (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aMoc6kowoHUuomOkGZCz2TQ",
    name: "TellTale \u2013 Multiplex System (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "XX010",
  },
  {
    id: "aUIKu1EGarkGv4qhSrNc7Jg",
    name: "TellTale \u2013 Battery pack (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2632",
  },
  {
    id: "atin0Q-vjV0auefF6Pa3sjA",
    name: "TellTale \u2013 High voltage system caution (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "6042",
  },
  {
    id: "aM4ltq0_4Fkqsfg9Hx2i5eA",
    name: "TellTale \u2013 Battery pack temperature (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "3129",
  },
  {
    id: "aForCNy9bmkKAnQA_ztgUuQ",
    name: "TellTale \u2013 Electric motor limited performance (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2639",
  },
  {
    id: "a01raEmIpu0-LeBcgeDGgrw",
    name: "TellTale \u2013 Battery pack cooling (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "2455",
  },
  {
    id: "aMJSAogyJjkyLIA-i_BEGGw",
    name: "TellTale \u2013 Reserved for FMS-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a_zd_xpgTPU6PyBVIAhsMcg",
    name: "TellTale \u2013 Reserved for FMS-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "akgiq338k_0qN6e1bAeyZfw",
    name: "TellTale \u2013 Reserved for FMS-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "ae414gjTHs06OQKqNnFkgug",
    name: "TellTale \u2013 Reserved for FMS-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "acplCC0tay0GueoYgT1UBAA",
    name: "TellTale \u2013 Reserved for FMS-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "akiNWUOjk90uh_Jd1uZfTng",
    name: "TellTale \u2013 Reserved for FMS-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aXdzzgXw15kStyrLEKkuqEg",
    name: "TellTale \u2013 Traction control fault (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aX9FYiOwLiUSdbLBGTxctAQ",
    name: "TellTale \u2013 Battery level low (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "adeg06Cb5j0GZPijTVQv15g",
    name: "TellTale \u2013 Charging status (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aB16SkA6pmk2OoUvHHDH15g",
    name: "TellTale \u2013 Traction battery balancing (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "afMc7-DI_e0aG4hmnMs5Tuw",
    name: "TellTale \u2013 High voltage sector network malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aP0THZyg1cEC6WeVOqmRPVw",
    name: "TellTale \u2013 High voltage emergency shutdown (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a-4huBKmKZ0iXdL96g-GtlA",
    name: "TellTale \u2013 Insulation monitoring (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aTfPs9-e08U-aUM-mHMiGNg",
    name: "TellTale \u2013 Temperature cooling system - high voltage battery too high (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "ayxEq451eKES6sMgUhw6Zqw",
    name: "TellTale \u2013 Cooling system - high voltage battery malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aqQ1D4g7JoUG08WFqV-JROw",
    name: "TellTale \u2013 Pantograph status (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aBt7o_8DUb0iTpaEfO7L7pw",
    name: "TellTale \u2013 Batter charging system - 24V malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a4tlUxE7SOEyqyGK8RR5y5w",
    name: "TellTale \u2013 Heating system malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "askz8oTNkBUewL4dn_8PsHg",
    name: "TellTale \u2013 Additional heating (fossil fuel) active (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aZbbddDrEUkGSif-B5UTv-g",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "agAbopgpSq0m0-JxfwXVGPw",
    name: "TellTale \u2013 Additional heating status (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "axuRqC2zXiESCWEKQhGCOGA",
    name: "TellTale \u2013 Fire alarm system malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "ahZFhjX5oMUicWbNVU7TwDA",
    name: "TellTale \u2013 Fire report (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "afhxncTYbJUCXpg1BGwhzPg",
    name: "TellTale \u2013 Traction motor temperature too high (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "am5uTt6qKhUmB5B7lx26NiA",
    name: "TellTale \u2013 Storage pressure braking system (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aCTLw47Tgo0ezx-cdkjJA3A",
    name: "TellTale \u2013 Wheelchair ramp status (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aBbOKy5nI102TO2_TjGXdog",
    name: "TellTale \u2013 Disturbance at doors (global) (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "abQbyfudFeESenBkAk-tsgA",
    name: "TellTale \u2013 Tire pressure status (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a6rjaCwOB5Ee6k1chJ2YH2Q",
    name: "TellTale \u2013 Air compressor malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "ahWocZGwDNECRDrgKVQJ6Bw",
    name: "TellTale \u2013 Air compressor oil level low (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aNcT7LMWMUEOWUufstkouMg",
    name: "TellTale \u2013 Driver door (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aJiKTwlXHlEuBsr_EAMwjww",
    name: "TellTale \u2013 Recuperation malfunction (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a0ZADtryiwU-wLxo-tHcAHg",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aMFnL8c6s00eOZUIgXGdn-Q",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aquYkr-R3gkGZMkbCN8-O9Q",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "ac3zu7Gwc7Umi_uO6I-tfPg",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aKSStGhlT2UaYx6SaqLTj4g",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aV02jF78ON0yxKtd73zczmw",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aPMR_dbRO5UyLV8KDrOg7Zg",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "avq3oclFPQ0mYMw4EZwGktA",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a-X8-vYR0Bk2ecVILZa7B3A",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aSFrqIYCkYEGYuGigDu0gXw",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "alAlKgQY14kOBxo_BZCwg-g",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a_PtHd5E2lUK-rrvazNx1-A",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "a71oJYuHUqUyRrObqlR249A",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "ahGADvBdUbkiumcbBrEQUSQ",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aWS6jdmrULUOgBr1JVrgM0w",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "awfj1r-GkXk-1CzKYwgHSdA",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "akWmqbhs2sUi9IAR2lSixoQ",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
  {
    id: "aZ0a4kzxOWk2V7whWfM6u_g",
    name: "TellTale \u2013 Reserved for VDV-Standard (0 = off / 1 = red / 2 = yellow / 3 = information / 4 = reserved / 5 = reserved / 6 = reserved / 7 = not available)",
    iso: "-1",
  },
];
